import { useState, useRef } from "react";

import { API_URL, isFieldError } from "../helpers";

import Input from "../components/Input";
import Select from "../components/Select";
import Checkbox from "../components/Checkbox";
import Msg from "../components/Msg";
import Submit from "../components/Submit";
import Notice from "../components/Notice";

const Tr = ({ data }) => {
	return (
		<tr>
			<td>{data.event}</td>
			<td
				className={
					data.status === 1
						? "left success"
						: data.status === 0
						? "left error"
						: "left working"
				}
			>
				<div className="flex">
					<i
						className={
							data.status === 1
								? "fa fa-check-circle"
								: data.status === 0
								? "fa fa-times-circle"
								: "fa fa-info-circle"
						}
					/>
					<span>{data.text}</span>
				</div>
			</td>
		</tr>
	);
};

const Registration = ({ details }) => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		prefix: details.prefix,
		fname: details.fname,
		lname: details.lname,
		title: details.title,
		organization: details.organization,
		email: details.email,
		phone: details.phone,
		homeIntl: details.country ? true : false,
		homeAddress: details.address,
		homeCity: details.city,
		homeSt: details.st,
		homeZip: details.zip,
		homeCountry: details.country,
		employee: details.employee,
		cubicle: details.cubicle,
		rental: details.rental,
		shirt: details.shirt,
		boot: details.boot,
		sportingFirst: details.sportingFirst,
		sportingAccept: details.sportingAccept,
	});
	const [msg, setMsg] = useState({});

	const formElement = useRef(null);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/guestRegistration`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (
				key === "homeIntl" ||
				key === "sportingFirst" ||
				key === "sportingAccept"
			) {
				data.append(key, value ? "1" : "0");
			} else {
				data.append(key, value);
			}
		});
		data.append("golfStatus", details.invite.golf.status);
		data.append("sportingStatus", details.invite.sporting.status);
		data.append("welcomeStatus", details.invite.welcome.status);
		data.append("giftStatus", details.invite.gift.status);
		data.append("id", details.id);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({
					type: "success",
					text: json.text,
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			<p>
				Use this page to update your registration details and view invitation
				statuses.
			</p>

			{details.invite.golf.status === 3 &&
			details.invite.sporting.status === 3 &&
			details.invite.welcome.status === 3 &&
			details.invite.gift.status === 3 ? null : !names.homeAddress ? (
				<Notice
					data={{
						type: "notice",
						text: "Your registration details need to be completed, please use the form below.",
					}}
				/>
			) : null}

			<div className="spacer"></div>

			<table className="approved">
				<thead>
					<tr>
						<th style={{ width: "33%" }}>Sponsor Name</th>
						<th style={{ width: "34%" }}>Organization</th>
						<th style={{ width: "33%" }}>Email</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td className="center">{details.registration.name}</td>
						<td className="center">{details.registration.organization}</td>
						<td className="center">
							<a href={`mailto:${details.registration.email}`}>
								{details.registration.email}
							</a>
						</td>
					</tr>
				</tbody>
			</table>

			<table className="approved assigned">
				<thead>
					<tr>
						<th colSpan="2" className="hdg">
							Your Event Statuses
						</th>
					</tr>
					<tr>
						<td style={{ width: "30%" }}>Event</td>
						<td className="left">Status</td>
					</tr>
				</thead>

				<tbody>
					<Tr
						data={{
							...details.invite.golf,
							event: "Golf",
							id: details.id,
						}}
					/>
					<Tr
						data={{
							...details.invite.sporting,
							event: "Sporting Clays",
							id: details.id,
						}}
					/>
					<Tr
						data={{
							...details.invite.welcome,
							event: "Welcome Party",
							id: details.id,
						}}
					/>
					<Tr
						data={{
							...details.invite.gift,
							event: "Gift Package",
							id: details.id,
						}}
					/>
				</tbody>
			</table>

			<div
				className="blocktext"
				style={{ marginTop: "25px", marginBottom: "25px" }}
			>
				Questions or need to change your invitation status? Please contact your
				sponsor, {details.registration.name} at {details.registration.phone} or
				email{" "}
				<a href={`mailto:${details.registration.email}`}>
					{details.registration.email}
				</a>
				.
			</div>

			<form
				ref={formElement}
				method="post"
				action="/"
				onSubmit={(e) => handleSubmit(e)}
				className={
					details.invite.golf.status === 3 &&
					details.invite.sporting.status === 3 &&
					details.invite.welcome.status === 3 &&
					details.invite.gift.status === 3
						? "hidden"
						: "well"
				}
			>
				<div
					className={
						details.invite.sporting.status === 1 && names.sportingFirst
							? "hidden"
							: details.invite.sporting.status === 1
							? ""
							: "hidden"
					}
				>
					<p style={{ marginTop: "0", color: "red" }}>
						In order to preserve the safety of Valero’s employees, volunteers,
						vendors, partners, sponsors, participants and attendees of the
						sporting clays event,{" "}
						<strong>
							first time shooters are prohibited from participating in the
							Benefit for Children Sporting Clays event.
						</strong>
					</p>

					<div
						className="form-group checkbox"
						style={{ marginTop: "0", marginBottom: "25px" }}
					>
						<Checkbox
							name="sportingFirst"
							label="By checking this box, you indicate you are not a first time shooter."
							checked={false}
							click={handleUpdate}
						/>
					</div>
				</div>

				<h4
					style={{
						marginTop: "0",
						lineHeight: "22px",
						marginBottom: "10px",
						fontSize: "1.1rem",
					}}
				>
					Contact Information
				</h4>

				<div className="form-group">
					<Select
						name="prefix"
						label="Prefix"
						reqd={true}
						value={names.prefix || ""}
						options={[
							{ id: "", name: "--" },
							{ id: "Mr.", name: "Mr." },
							{ id: "Mrs.", name: "Mrs." },
							{ id: "Ms.", name: "Ms." },
							{ id: "Dr.", name: "Dr." },
							{ id: "Other", name: "Other" },
						]}
						update={handleUpdate}
						error={isFieldError(errors, "prefix")}
					/>
					<div className="empty" />
				</div>

				<div className="form-group">
					<Input
						name="fname"
						label="First Name"
						reqd={true}
						value={names.fname || ""}
						autocomplete="given-name"
						update={handleUpdate}
						errors={errors}
					/>

					<Input
						name="lname"
						label="Last Name"
						reqd={true}
						value={names.lname || ""}
						autocomplete="family-name"
						update={handleUpdate}
						errors={errors}
					/>
				</div>

				<div className="form-group">
					<Input
						name="title"
						label="Title"
						reqd={true}
						value={names.title || ""}
						autocomplete="organization-title"
						update={handleUpdate}
						errors={errors}
					/>
					<Input
						name="organization"
						label="Organization"
						reqd={true}
						value={names.organization || ""}
						autocomplete="organization"
						update={handleUpdate}
						errors={errors}
					/>
				</div>

				<div className="form-group">
					<Input
						name="email"
						label="Email"
						reqd={true}
						value={names.email || ""}
						update={handleUpdate}
						errors={errors}
					/>
					<Input
						name="phone"
						label="Phone"
						reqd={true}
						value={names.phone || ""}
						autocomplete="tel"
						update={handleUpdate}
						errors={errors}
					/>
				</div>

				<h4
					style={{
						marginTop: "15px",
						lineHeight: "22px",
						marginBottom: "10px",
						fontSize: "1.1rem",
					}}
				>
					Home Shipping Address
				</h4>

				<div className="form-group checkbox" style={{ marginTop: "10px" }}>
					<Checkbox
						name="homeIntl"
						label="Check if your home address is International (not US or CA)"
						checked={false}
						click={handleUpdate}
					/>
				</div>

				<div className="form-group one">
					<Input
						name="homeAddress"
						label="Address"
						reqd={true}
						value={names.homeAddress || ""}
						autocomplete="street-address"
						update={handleUpdate}
						errors={errors}
					/>
				</div>

				<div className="form-group three">
					<Input
						name="homeCity"
						label="City"
						reqd={true}
						value={names.homeCity || ""}
						autocomplete="address-level2"
						update={handleUpdate}
						errors={errors}
					/>

					{!names.homeIntl && (
						<Input
							name="homeSt"
							label="State (2-letter)"
							reqd={true}
							value={names.homeSt || ""}
							autocomplete="address-level1"
							update={handleUpdate}
							errors={errors}
						/>
					)}

					<Input
						name="homeZip"
						label="Zip Code"
						reqd={true}
						value={names.homeZip || ""}
						autocomplete="postal-code"
						update={handleUpdate}
						errors={errors}
					/>

					{names.homeIntl && (
						<Input
							name="homeCountry"
							label="Country Code (2-letter)"
							reqd={true}
							value={names.homeCountry || ""}
							autocomplete="cuntry"
							update={handleUpdate}
							errors={errors}
						/>
					)}
				</div>

				<div className="form-group" style={{ marginTop: "20px" }}>
					<Select
						name="employee"
						label="Are you a Valero SAHQ Employee?  (Please only select “Yes” if your office/cubicle is located in the San Antonio office)"
						reqd={true}
						value={names.employee || ""}
						options={[
							{ id: "", name: "--" },
							{ id: "Yes", name: "Yes" },
							{ id: "No", name: "No" },
						]}
						update={handleUpdate}
						error={isFieldError(errors, "employee")}
					/>

					{names.employee === "Yes" ? (
						<Input
							name="cubicle"
							label="Office/Cubicle Number"
							reqd={true}
							value={names.cubicle || ""}
							autocomplete="off"
							update={handleUpdate}
							errors={errors}
						/>
					) : (
						<div className="empty" />
					)}
				</div>

				<div className={details.invite.golf.status === 1 ? "" : "hidden"}>
					<h4
						style={{
							marginTop: "0",
							lineHeight: "22px",
							marginBottom: "10px",
							fontSize: "1.1rem",
						}}
					>
						Golf Information
					</h4>

					<div className="form-group">
						<Select
							name="rental"
							label="Do you need Rental Clubs?"
							reqd={true}
							value={names.rental || ""}
							options={[
								{ id: "", name: "--" },
								{
									id: "I will bring my own clubs",
									name: "I will bring my own clubs",
								},
								{ id: "Men’s Left", name: "Men’s Left" },
								{ id: "Men’s Right", name: "Men’s Right" },
								{ id: "Women’s Left", name: "Women’s Left" },
								{ id: "Women’s Right", name: "Women’s Right" },
							]}
							update={handleUpdate}
							error={isFieldError(errors, "rental")}
							note="Due to the large number of guests, we ask that you please bring your own clubs if possible!"
						/>

						<div className="empty" />

						{/* removed 11/8/23 per Samantha <Input
							name="shoe"
							label="Shoe Size"
							reqd={true}
							value={names.shoe || ""}
							update={handleUpdate}
							errors={errors}
						/>*/}
					</div>
				</div>

				<div
					className={
						details.invite.sporting.status === 1 && names.sportingAccept
							? "hidden"
							: details.invite.sporting.status === 1
							? ""
							: "hidden"
					}
				>
					<h4
						style={{
							marginTop: "25px",
							lineHeight: "22px",
							marginBottom: "10px",
							fontSize: "1.1rem",
						}}
					>
						Sporting Clays Information
					</h4>

					<p style={{ color: "red" }}>
						By checking this box, you are certifying that the registered
						participant (i) is familiar with the use and operation of the
						shotgun(s) that he/she will be using during this event and with the
						rules of shooting and firearm safety, (ii) has previously
						participated in trap, skeet, or sporting clays events or
						participated in similar sporting or hunting activities (e.g., wing
						shooting), and (iii) understands that this activity is potentially
						or inherently dangerous, and that he/she assumes full responsibility
						for his/her conduct and for any injuries or property damage he/she
						may cause or sustain while engaging in this activity. Participation
						in the event may be immediately terminated for any violation of
						facility rules or any safety reason.
					</p>

					<div
						className="form-group checkbox"
						style={{ marginTop: "0", marginBottom: "25px" }}
					>
						<Checkbox
							name="sportingAccept"
							label="By checking this box, you indicate acceptance of the above participation disclaimer."
							checked={false}
							click={handleUpdate}
						/>
					</div>
				</div>

				<div className={details.invite.gift.status === 1 ? "" : "hidden"}>
					<h4
						style={{
							marginTop: "0",
							lineHeight: "22px",
							marginBottom: "10px",
							fontSize: "1.1rem",
						}}
					>
						Gift Package Information
					</h4>

					{details.invite.golf.status === 1 ||
					details.invite.sporting.status === 1 ||
					details.invite.gift.status === 1 ? (
						<div className="form-group">
							<Select
								name="shirt"
								label="Shirt Size"
								reqd={true}
								value={names.shirt || ""}
								options={[
									{ id: "", name: "--" },
									{ id: "Men’s S", name: "Men’s S" },
									{ id: "Men’s M", name: "Men’s M" },
									{ id: "Men’s L", name: "Men’s L" },
									{ id: "Men’s XL", name: "Men’s XL" },
									{ id: "Men’s XXL", name: "Men’s XXL" },
									{ id: "Men’s 3XL", name: "Men’s 3XL" },
									{ id: "Women’s S", name: "Women’s S" },
									{ id: "Women’s M", name: "Women’s M" },
									{ id: "Women’s L", name: "Women’s L" },
									{ id: "Women’s XL", name: "Women’s XL" },
								]}
								update={handleUpdate}
								error={isFieldError(errors, "shirt")}
							/>
							<div className="empty" />

							{/*details.invite.sporting.status === 1 ? (
								<Select
									name="boot"
									label="Snake Boot Size"
									reqd={true}
									value={names.boot || ""}
									options={[
										{ id: "", name: "--" },
										{ id: "Men’s 7", name: "Men’s 7" },
										{ id: "Men’s 7.5", name: "Men’s 7.5" },
										{ id: "Men’s 8", name: "Men’s 8" },
										{ id: "Men’s 8.5", name: "Men’s 8.5" },
										{ id: "Men’s 9", name: "Men’s 9" },
										{ id: "Men’s 9.5", name: "Men’s 9.5" },
										{ id: "Men’s 10", name: "Men’s 10" },
										{ id: "Men’s 10.5", name: "Men’s 10.5" },
										{ id: "Men’s 11", name: "Men’s 11" },
										{ id: "Men’s 11.5", name: "Men’s 11.5" },
										{ id: "Men’s 12", name: "Men’s 12" },
										{ id: "Men’s 13", name: "Men’s 13" },
										{ id: "Men’s 14", name: "Men’s 14" },
										{ id: "Women’s 5", name: "Women’s 5" },
										{ id: "Women’s 6", name: "Women’s 6" },
										{ id: "Women’s 7", name: "Women’s 7" },
										{ id: "Women’s 8", name: "Women’s 8" },
										{ id: "Women’s 9", name: "Women’s 9" },
										{ id: "Women’s 10", name: "Women’s 10" },
										{ id: "Women’s 11", name: "Women’s 11" },
									]}
									update={handleUpdate}
									error={isFieldError(errors, "boot")}
								/>
							) : (
								<div className="empty" />
							)*/}
						</div>
					) : (
						<div className="form-group"></div>
					)}
				</div>

				{details.invite.gift.status === 1 &&
					details.invite.sporting.status === 1 && (
						<p>
							Sizing is standard to the Brannock Device. Boots run true to size.
						</p>
					)}

				<div className="msg-submit">
					{msg.type && <Msg data={msg} />}

					<div
						className={
							msg.type === "working" || msg.type === "success"
								? "hidden"
								: "submit-container"
						}
					>
						<Submit submit="Submit / Update Registration" />
					</div>
				</div>
			</form>
		</>
	);
};
export default Registration;
